<lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
  <div mat-dialog-title class="dialog-header">
    <h3 class="dialog-title">Add Extension Group</h3>
    <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
  </div>
  <form [formGroup]="form" (ngSubmit)="onCreate()" autocomplete="off">
    <mat-dialog-content class="add-extension-group-dialog-content">
      <div class="detail-right-column">
        <mat-form-field class="flex-half">
          <mat-label>Display Name</mat-label>
          <input matInput autocomplete="off" type="text" formControlName="name" id="name" #name required />
          @if (form.get('name')?.hasError('required')) {
            <mat-error> A name is required. </mat-error>
          }
          @if (!form.get('name')?.hasError('required') && form.get('name')?.hasError('noContent')) {
            <mat-error>
              Name must contain characters.
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="flex-half">
          <mat-label>Description</mat-label>
          <input matInput autocomplete="off" type="text" formControlName="description" id="description" />
        </mat-form-field>
        <div class="flex-half extension-multi-select">
          <ndt-extension-advanced-multi-select
            [accountIdFilter]="accountId"
            [itemsControl]="form.controls.extensionGroupExtensions"
            [extensionTypesToInclude]="extensionGroupMemberTypes"
            [parentDirty]="form.controls.extensionGroupExtensions.dirty"
            (change)="emitAddExtensionGroupExtensionsChange()"
            >
            </ndt-extension-advanced-multi-select
          ></div>
        </div>
      </mat-dialog-content>
      <mat-dialog-actions>
        <button type="submit" title="Create" mat-raised-button id="e79cc07e-02a4-4f1e-9d29-711ac67f3b04">Save</button>
      </mat-dialog-actions>
    </form>
  </lcs-loading-overlay>
